module.exports = "/static/assets/0003d379a621d85693a57795339255cd.png";